import { Paso } from './Paso';

export class PasoMemoria extends Paso {
  constructor() {
    super(
      false,
      'Memorias',
      `Las memorias sirven para cargar y almacenar todas las instrucciones que se ejecutan en el procesador. Lo que se debe tener en cuenta en esta sección
      es el tamaño, la frecuencia y la cantidad de módulos`,
      4,
      'ram.png',
      'ram.png',
      false,
      [],
      '',
    );
  }
}
